module.exports = __webpack_public_path__ + "img/logo-branco.8bb40410.svg";